import React from 'react'

export default () => (
  <React.Fragment>
    <span>&copy; 2018 <a href="https://www.e-solutions.cz/">e-solutions.cz</a></span>
  </React.Fragment>
)
